<template>
  <div class="gcb" :class="['gcb--' + block.theme, { 'gcb--open': open }]">
    <!-- 块头：点击展开/折叠 -->
    <div class="gcb__head" @click="open = !open">
      <span class="gcb__badge" :class="{ 'gcb__badge--fixed': block.fixed }">{{ block.no }}</span>
      <span class="gcb__stag" :class="{ 'gcb__stag--fixed': block.fixed }">{{ block.fixed ? '固定图' : '生成图' }}</span>
      <span class="gcb__title">{{ block.title }}</span>
      <span class="gcb__side">
        <span v-if="!open && !block.fixed" class="gcb__refcnt">参考图1张</span>
        <span class="gcb__fold">{{ open ? '⌃' : '⌄' }}</span>
      </span>
    </div>

    <!-- 块体：固定图只需上传素材，无需生成配置 -->
    <div v-show="open && block.fixed" class="gcb__body">
      <div class="gcb__fixed">
        <span class="gcb__fixed-upload">＋<br />上传固定图</span>
        <span class="gcb__fixed-hint">该图为模板固定图，无需AI生成配置，上传品牌素材/设计稿即可（支持 JPG、PNG）</span>
      </div>
    </div>

    <!-- 块体：详细配置 -->
    <div v-show="open && !block.fixed" class="gcb__body">
      <div class="gcb__cols">
        <!-- 左：参考图 -->
        <div class="gcb__col">
          <div style="display: flex;align-items: center;justify-content: space-between;">
           <div class="gcb__coltitle">参考图 <em>选1-5张</em></div>
            <div class="gcb__imgtabs">
              <span
                v-for="t in ['主图', 'SKU图', '详情页']"
                :key="t"
                class="gcb__imgtab"
                :class="{ 'gcb__imgtab--on': t === imgTab }"
                @click="imgTab = t"
              >{{ t }}</span>
            </div>
          </div>
         
          <div class="gcb__imgslots">
            <span v-for="n in 3" :key="n" class="gcb__imgslot gcb__imgslot--pick">
              <span class="gcb__imgslot-badge">{{ n }}</span>图
            </span>
            <span class="gcb__imgslot gcb__imgslot--empty">–</span>
            <span class="gcb__imgslot gcb__imgslot--empty">–</span>
            <span class="gcb__imgslot gcb__imgslot--add">＋<br />上传</span>
          </div>
          <div class="gcb__cfg-foot">已选 <b>2</b>/5 张 · {{ imgTab }}</div>
        </div>

        <!-- 右：参考来源 · 模板库（三种模式一致） -->
        <div class="gcb__col">
          <div class="gcb__coltitle" style="margin: 12px 0;">参考来源 · {{ refTplTitle }} <a class="gcb__cfg-more">全部→</a></div>
          <div class="gcb__tpls">
            <span
              v-for="(t, ti) in templates"
              :key="t"
              class="gcb__tpl"
              :class="{ 'gcb__tpl--on': ti === tplSel }"
              @click="tplSel = ti"
            >
              <span class="gcb__tpl-ico">{{ tplIcons[ti] }}</span>
              <span class="gcb__tpl-name">{{ t }}</span>
            </span>
          </div>
          <div class="gcb__refarea">
            <div class="gcb__refhint">参考图（可选）</div>
            <div class="gcb__refslot">
              <span class="gcb__imgslot gcb__imgslot--add">＋<br />上传</span>
              <span class="gcb__refhint">可与模板同时使用</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 模特人脸（选配） -->
      <div class="gcb__sub">
        <div class="gcb__subhead">
          <span class="gcb__coltitle gcb__coltitle--row">模特人脸 <em>选配</em></span>
          <span class="gcb__switch" :class="{ 'gcb__switch--on': faceOn }" @click.stop="faceOn = !faceOn"><i></i></span>
        </div>
        <div v-if="faceOn" class="gcb__face">
          <div class="gcb__face-tabs">
            <button type="button" class="gcb__face-tab" :class="{ 'gcb__face-tab--on': faceTab === 'ai' }" @click="faceTab = 'ai'">
              <span class="gcb__ft-ico">🧑‍🎨</span>AI模特库
            </button>
            <button type="button" class="gcb__face-tab" :class="{ 'gcb__face-tab--on': faceTab === 'custom' }" @click="faceTab = 'custom'">
              <span class="gcb__ft-ico gcb__ft-ico--gold">✨</span>自定义模特
            </button>
            <button type="button" class="gcb__face-tab" :class="{ 'gcb__face-tab--on': faceTab === 'upload' }" @click="faceTab = 'upload'">
              <span class="gcb__ft-ico">⬆</span>上传人脸
            </button>
          </div>
          <template v-if="faceTab === 'ai'">
            <div class="gcb__face-grid">
              <div
                v-for="f in faceModels"
                :key="f.id"
                class="gcb__face-card"
                :class="{ 'gcb__face-card--on': faceSel === f.id }"
                @click="faceSel = f.id"
              >
                <span class="gcb__face-ico">{{ f.icon }}</span>
                <span class="gcb__face-name">{{ f.name }}</span>
              </div>
            </div>
            <div class="gcb__face-tip">全部模特为AI生成，无肖像权问题</div>
          </template>
          <template v-else-if="faceTab === 'custom'">
            <textarea v-model="faceCustom" class="gcb__face-textarea" placeholder="25-30岁亚洲女性、气质知性、微笑状态..."></textarea>
            <div class="gcb__face-tip">系统生成AI虚拟模特，不涉及真实肖像</div>
          </template>
          <template v-else>
            <div class="gcb__face-uploadbox">
              <span class="gcb__face-uploadico">⬆</span>
              <span class="gcb__face-uploadtxt">上传人脸照片</span>
            </div>
            <div class="gcb__face-tip gcb__face-tip--red">⚠ 上传即代表你确认拥有该人脸的合法使用权利（本人需已获授权）</div>
          </template>
        </div>
      </div>

      <!-- 底部：提示词（左） + 图片文案（右） -->
      <div class="gcb__bottom">
        <!-- 提示词 -->
        <div class="gcb__sub gcb__sub--prompt">
          <span class="gcb__coltitle">提示词</span>
          <div class="gcb__prompt-tags">
            <span v-for="t in promptTags" :key="t" class="gcb__ptag">{{ t }}</span>
          </div>
          <input v-model="promptExtra" class="gcb__prompt-input" placeholder="补充说明…" />
        </div>

        <!-- 图片文案 -->
        <div class="gcb__sub gcb__sub--copy">
          <span class="gcb__coltitle">图片文案</span>
          <div class="gcb__copyopts">
            <label class="gcb__copyopt" :class="{ 'gcb__copyopt--on': copyOpt === 'keep' }" @click="copyOpt = 'keep'">
              <span class="gcb__radio" :class="{ 'gcb__radio--on': copyOpt === 'keep' }"></span>
              <b>保留参考图文案</b>
            </label>
            <label class="gcb__copyopt" :class="{ 'gcb__copyopt--on': copyOpt === 'new' }" @click="copyOpt = 'new'">
              <span class="gcb__radio" :class="{ 'gcb__radio--on': copyOpt === 'new' }"></span>
              <b>按产品属性生成</b>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenConfigBlock',
  props: {
    // { key, no, theme: 'red'|'gold'|'blue'|'purple', activeTab, title }
    block: { type: Object, required: true },
    mode: { type: String, default: 'copy' },
    templates: { type: Array, default: () => [] },
    tplIcons: { type: Array, default: () => [] },
    faceModels: { type: Array, default: () => [] },
    promptTags: { type: Array, default: () => [] }
  },
  data() {
    return {
      open: this.block.no === 1,
      imgTab: this.block.activeTab || '主图',
      tplSel: 0,
      faceOn: false,
      faceTab: 'ai',
      faceSel: 'A',
      faceCustom: '',
      copyOpt: 'keep',
      promptExtra: ''
    }
  },
  computed: {
    // 参考来源模板库名称随生成方式变化
    refTplTitle() {
      if (this.mode === 'style') return '风格模板库'
      if (this.mode === 'custom') return '参考模板库'
      return '复刻模板库'
    }
  }
}
</script>

<style scoped>
.gcb {
    --accent: #C8443C;
    --accent-bg: #FDF0EF;
    --accent-border: #F3C4C0;
    border: 1px solid #E4E7ED;
    border-radius: 8px;
    background: #fff;
    margin: 10px 12px 12px;
    overflow: hidden;
}
.gcb--gold { --accent: #C99A1B; --accent-bg: #FCF4DC; --accent-border: #F0E2A8; }
.gcb--blue { --accent: #409EFF; --accent-bg: #EAF4FF; --accent-border: #C6E2FF; }
.gcb--purple { --accent: #7C3AED; --accent-bg: #F3ECFE; --accent-border: #D5C2F8; }
.gcb--open { border-color: var(--accent-border); }
.gcb--open.gcb--red { background: #FFFCFC; }
.gcb--open.gcb--gold { background: #FFFCF4; }
.gcb--open.gcb--blue { background: #FCFDFF; }
.gcb--open.gcb--purple { background: #FDFCFF; }

/* 块头 */
.gcb__head {
    display: flex; align-items: center; gap: 8px;
    padding: 9px 12px; cursor: pointer; user-select: none;
    background: #FAFAFA;
}
.gcb--open .gcb__head { background: var(--accent-bg); }
.gcb__badge {
    width: 18px; height: 18px; border-radius: 50%; flex-shrink: 0;
    display: inline-flex; align-items: center; justify-content: center;
    font-size: 10px; font-weight: bold;
    background: rgb(203, 213, 225); color: #fff; border: 1px solid rgb(203, 213, 225);
}
.gcb--open .gcb__badge { background: var(--accent); color: #fff; border-color: var(--accent); }
.gcb__badge--fixed { background: #FDF6EC; color: #E6A23C; border-color: #F5DAB1; }
.gcb__stag {
    font-size: 10px; padding: 1px 7px; border-radius: 3px; flex-shrink: 0;
    background: #F0F9EB; color: #67C23A; border: 1px solid #E1F3D8;
}
.gcb__stag--fixed { background: #FDF6EC; color: #E6A23C; border-color: #F8E3BF; }
/* .gcb--open .gcb__stag { background: #fff; color: var(--accent); border-color: var(--accent-border); font-weight: bold; } */
.gcb--open .gcb__stag--fixed { color: #E6A23C; border-color: #F5DAB1; }
.gcb__title { font-size: 13px; color: #909399; flex: 1; min-width: 0; }
.gcb--open .gcb__title { color: #303133; font-weight: bold; }
.gcb__side { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }
.gcb__refcnt { font-size: 11px; color: #B0B4BB; }
.gcb__fold { font-size: 13px; color: #B0B4BB; }
.gcb--open .gcb__fold { color: var(--accent); }

/* 块体 */
.gcb__body { padding: 12px; border-top: 1px solid #F0F0F0; }

/* 固定图块体 */
.gcb__fixed { display: flex; align-items: center; gap: 14px; }
.gcb__fixed-upload {
    width: 96px; height: 72px; flex-shrink: 0;
    background: #fff; border: 1px dashed #F0CE8A; border-radius: 8px;
    color: #E6A23C; font-size: 12px; line-height: 1.5; text-align: center;
    display: inline-flex; align-items: center; justify-content: center; cursor: pointer;
}
.gcb__fixed-hint { font-size: 12px; color: #B0B4BB; line-height: 1.7; }
.gcb__cols { display: grid; grid-template-columns: 1fr 1.2fr; gap: 14px; }
.gcb__col { background: #F7F8FA; border-radius: 6px; padding: 12px 14px; }
.gcb__coltitle { font-size: 12px; font-weight: bold; color: #303133; }
.gcb__coltitle em { font-style: normal; font-size: 11px; color: #B0B4BB; font-weight: normal; margin-left: 4px; }
.gcb__coltitle--row { display: inline-flex; align-items: center; }
.gcb__cfg-more { float: right; color: var(--accent); font-size: 12px; font-weight: normal; cursor: pointer; }

.gcb__imgtabs { display: flex; gap: 4px; margin: 10px 0;background: rgb(240, 242, 245);padding: 2px; }
.gcb__imgtab {
    font-size: 11px; padding: 2px 10px; border-radius: 3px; color: #909399; cursor: pointer;
}
.gcb__imgtab--on { background: #fff; color: var(--accent); font-weight: bold; box-shadow: 0 1px 3px rgba(0,0,0,.08); }

.gcb__imgslots { display: flex; gap: 8px; }
.gcb__imgslot {
    position: relative; width: 46px; height: 46px; border-radius: 6px;
    background: #ECEAE6; color: #8A8378; font-size: 13px;
    display: inline-flex; align-items: center; justify-content: center; text-align: center;
}
.gcb__imgslot--pick { background: #E8E2DC; border: 2px solid var(--accent); }
.gcb__imgslot-badge {
    position: absolute; right: -5px; top: -5px; width: 15px; height: 15px; border-radius: 50%;
    background: var(--accent); color: #fff; font-size: 10px;
    display: flex; align-items: center; justify-content: center;
}
.gcb__imgslot--empty { background: #F2F3F5; color: #C0C4CC; }
.gcb__imgslot--add {
    background: #fff; border: 1px dashed #C0C4CC; color: #B0B4BB; font-size: 11px; line-height: 1.3;
    cursor: pointer;
}
.gcb__cfg-foot { margin-top: 8px; font-size: 11px; color: #909399; }
.gcb__cfg-foot b { color: var(--accent); }

.gcb__tpls { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 12px; }
.gcb__tpl {
    width: 62px; border: 1px solid #E4E7ED; border-radius: 6px; background: #fff;
    text-align: center; padding: 6px 2px; cursor: pointer; white-space: pre-line;
}
.gcb__tpl--on { border-color: var(--accent); background: var(--accent-bg); }
.gcb__tpl-ico { display: block; font-size: 15px; color: #606266; margin-bottom: 3px; }
.gcb__tpl-name { font-size: 10px; color: #606266; }
.gcb__refarea { display: flex; gap: 10px; flex-direction: column; justify-content: flex-start; }
.gcb__refslot { display: flex; align-items: center; gap: 5px; }
.gcb__refhint { font-size: 11px; color: #B0B4BB; line-height: 1.5; }

.gcb__sub { 
    margin-top: 12px;
    padding: 8px 10px;
    border-radius: 6px;
    background: rgb(246, 247, 250);
    border: 1px solid rgb(224, 224, 236);
   }
.gcb__subhead { display: flex; align-items: center; justify-content: space-between; }
.gcb__sub .gcb__coltitle { display: block; margin-bottom: 8px; }
.gcb__subhead .gcb__coltitle { margin-bottom: 0; }

/* 开关 */
.gcb__switch {
    width: 34px; height: 18px; border-radius: 10px; background: #DCDFE6;
    position: relative; cursor: pointer; transition: background .2s; flex-shrink: 0;
}
.gcb__switch i {
    position: absolute; left: 2px; top: 2px; width: 14px; height: 14px; border-radius: 50%;
    background: #fff; transition: left .2s;
}
.gcb__switch--on { background: var(--accent); }
.gcb__switch--on i { left: 18px; }

/* 模特人脸 */
.gcb__face { margin-top: 12px; }
.gcb__face-tabs {
    display: flex; gap: 4px; background: #F2F3F5; border-radius: 6px; padding: 4px; margin-bottom: 12px;
}
.gcb__face-tab {
    display: inline-flex; align-items: center; gap: 4px;
    font-size: 12px; color: #909399; background: transparent; border: none; outline: none;
    padding: 6px 14px; border-radius: 4px; cursor: pointer; white-space: nowrap;
}
.gcb__face-tab--on { background: #fff; color: var(--accent); font-weight: bold; box-shadow: 0 1px 4px rgba(0,0,0,.08); }
.gcb__ft-ico { font-size: 13px; line-height: 1; }
.gcb__ft-ico--gold { color: #E6A23C; }
.gcb__face-grid { display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 12px; }
.gcb__face-card {
    width: 82px; background: #fff; border: 1px solid #E4E7ED; border-radius: 8px;
    padding: 10px 4px 8px; display: flex; flex-direction: column; align-items: center; gap: 6px; cursor: pointer;
}
.gcb__face-card--on { border-color: var(--accent); background: var(--accent-bg); }
.gcb__face-ico { font-size: 28px; line-height: 1; }
.gcb__face-name { font-size: 11px; color: #606266; text-align: center; }
.gcb__face-card--on .gcb__face-name { color: var(--accent); }
.gcb__face-textarea {
    width: 100%; box-sizing: border-box; min-height: 64px; resize: vertical;
    border: 1px solid #DCDFE6; border-radius: 6px; padding: 8px 10px;
    font-size: 12px; color: #303133; line-height: 1.6; outline: none; margin-bottom: 12px;
    font-family: inherit;
}
.gcb__face-textarea:focus { border-color: var(--accent); }
.gcb__face-uploadbox {
    width: 96px; height: 96px; background: #fff; border: 1px dashed #C0C4CC; border-radius: 8px;
    display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px;
    cursor: pointer; margin-bottom: 12px;
}
.gcb__face-uploadico { font-size: 24px; color: #B0B4BB; line-height: 1; }
.gcb__face-uploadtxt { font-size: 11px; color: #909399; }
.gcb__face-tip {
    background: #FFF8E6; border-radius: 4px; padding: 8px 12px;
    font-size: 12px; color: #B8860B; line-height: 1.5;
}
.gcb__face-tip--red { background: #FEF0F0; color: #F56C6C; }

/* 底部两栏：提示词 + 图片文案（等长） */
.gcb__bottom {
    display: grid; grid-template-columns: 1fr 1fr; gap: 14px;
    margin-top: 12px;
}
@media (max-width: 900px) {
    .gcb__bottom { grid-template-columns: 1fr; }
    .gcb__cols { grid-template-columns: 1fr; }
}
.gcb__bottom .gcb__sub { margin-top: 0; }
.gcb__sub--prompt,
.gcb__sub--copy {
    background: #F7F8FA; border: 1px solid #EBEEF5; border-radius: 6px;
    padding: 12px 14px;
}

/* 提示词标签 */
.gcb__prompt-tags { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 10px; }
.gcb__ptag {
    font-size: 11px; color: #B8860B; background: #FCF8E8; border: 1px solid #F0E2A8;
    border-radius: 3px; padding: 2px 8px;
}
.gcb__prompt-input {
    width: 100%; box-sizing: border-box; height: 32px;
    border: none; border-radius: 6px; background: #fff;
    padding: 0 12px; font-size: 12px; outline: none; color: #303133;
}
.gcb__prompt-input::placeholder { color: #C0C4CC; }
.gcb__prompt-input:focus { box-shadow: 0 0 0 1px var(--accent-border); }

/* 图片文案（去卡片化） */
.gcb__copyopts { display: flex; flex-direction: column; gap: 10px; padding-top: 4px; }
.gcb__copyopt {
    display: flex; align-items: center; gap: 8px;
    cursor: pointer; background: transparent;
}
.gcb__copyopt b { font-size: 12px; color: #909399; font-weight: normal; }
.gcb__copyopt--on b { color: var(--accent); font-weight: bold; }
.gcb__radio {
    width: 14px; height: 14px; border-radius: 50%; border: 1px solid #C0C4CC;
    flex-shrink: 0; position: relative; background: #fff;
}
.gcb__radio--on { border-color: var(--accent); }
.gcb__radio--on::after {
    content: ''; position: absolute; left: 3px; top: 3px; width: 6px; height: 6px;
    border-radius: 50%; background: var(--accent);
}
</style>
